/** @jsx jsx */
import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {jsx} from '@instructure/emotion'
import {View} from '@instructure/ui-view'
import {setFeatures} from '@instructure/quiz-core/common/util/featureCheck'
import Alerts from '../../alerts'
import {filterSdkFeatures} from '../../../constants'

function PageComponent({
  children,
  header = null,
  footer = null,
  features = [],
  setSDKFeatures = setFeatures,
}) {
  useEffect(() => {
    if (features) {
      const enabledFlags = filterSdkFeatures(features)
      setSDKFeatures(enabledFlags)
    }
  }, [features])

  let pageProps = {height: '100%'}
  let contentProps = {height: 'inherit'}

  if (header) {
    contentProps = {
      ...contentProps,
      padding: 'xx-large none none none',
      // @ts-expect-error: There is no native functionality to handle @media print with InstUI props
      css: {'@media print': {paddingTop: '0 !important'}},
    }
  }
  if (footer) {
    pageProps = {minHeight: '100%', display: 'flex', css: {flexDirection: 'column'}}
    contentProps = {
      ...contentProps,
      css: {...contentProps.css, flex: 1},
    }
  }

  return (
    // Even though this tabIndex is not used directly,
    // for whatever reason, it makes the screenreader start at the top
    // of the page on pages without a header, when it otherwise wouldn't.
    <View as="div" className="page" {...pageProps} tabIndex="-1">
      <Alerts />
      {header}
      <View as="div" {...contentProps}>
        {children}
      </View>
      {footer}
    </View>
  )
}

// eslint-disable-next-line immutable/no-mutation
PageComponent.displayName = 'Page'

// eslint-disable-next-line immutable/no-mutation
PageComponent.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  footer: PropTypes.node,
  features: PropTypes.arrayOf(PropTypes.string),
  setSDKFeatures: PropTypes.func,
}

// eslint-disable-next-line immutable/no-mutation
PageComponent.defaultProps = {
  header: null,
  footer: null,
  features: [],
  setSDKFeatures: setFeatures,
}

export function mapStateToProps({features = []}) {
  return {features}
}

export const UnconnectedPage = PageComponent

export const Page = connect(mapStateToProps)(PageComponent)

export default Page
